'use client';
import { Dispatch, SetStateAction, createContext, useState } from 'react';
import ForexList from '@/components/molecules/ForexList/ForexList.client';
import ForexChart from './ForexChart';

type StoreProps = { symbol: string; name?: string };
type QuotesContextProps = {
  store: StoreProps;
  setStore: Dispatch<SetStateAction<StoreProps>>;
} | null;

export const QuotesContext = createContext<QuotesContextProps>(null);

type ForexListChartProps = {
  symbol: string;
};

const ForexListChart = ({ symbol }: ForexListChartProps) => {
  /**
   * token需要從server side來(隱藏實作邏輯)
   */
  const [store, setStore] = useState<StoreProps>({ symbol });

  return (
    <QuotesContext.Provider value={{ store, setStore }}>
      {/* 看看匯率 */}
      <ForexList />
      {/* TradingView圖表 */}
      <ForexChart />
    </QuotesContext.Provider>
  );
};

export default ForexListChart;
